"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGlobalNavMenu = useGlobalNavMenu;
var react_1 = require("react");
var router_1 = require("next/router");
var state_1 = require("../core/state");
function useGlobalNavMenu(items) {
    var _a;
    var router = (0, router_1.useRouter)();
    var globalNav = (0, state_1.useGlobalNav)();
    var globalNavId = (_a = globalNav === null || globalNav === void 0 ? void 0 : globalNav.selected) === null || _a === void 0 ? void 0 : _a.id;
    var currentItem = (0, react_1.useMemo)(function () {
        return items.find(function (link) {
            var _a, _b;
            return link.id.includes(router === null || router === void 0 ? void 0 : router.pathname) ||
                ((_b = (_a = link === null || link === void 0 ? void 0 : link.includedPaths) === null || _a === void 0 ? void 0 : _a.some) === null || _b === void 0 ? void 0 : _b.call(_a, function (path) { var _a, _b; return (_b = (_a = router === null || router === void 0 ? void 0 : router.pathname) === null || _a === void 0 ? void 0 : _a.includes) === null || _b === void 0 ? void 0 : _b.call(_a, path); }));
        }) || items[0];
    }, [items, router === null || router === void 0 ? void 0 : router.pathname]);
    return {
        items: items,
        tablist: {
            ariaLabel: 'Menu',
            defaultSelected: currentItem,
        },
        handleOnChange: function (pathname) {
            return router.push(pathname, {
                pathname: pathname,
                query: globalNavId ? { curriculaCode: globalNavId } : null,
            });
        },
    };
}
exports.default = useGlobalNavMenu;
